import type { Subscription } from "@/types/Subscription";
import validate from 'validate.js';

export interface User {
    id: string | null,
    name: string,
    default_workspace_id: string | null,
    created_at: string | null,
    email: string | null,
    profession: string | null,
    workplace: string | null,
    updated_at: string | null,
    subscriptions: Subscription[];
    ehr: string | null,
    phone: string | null
}

export interface UserValidationErrors {
    [attribute: string]: string[];
  }
  
  /**
   * Validates a given User object.
   *
   * @param user The User object to validate.
   * @returns An object with validation errors, or undefined if the user is valid.
   */
  export function validate_user(user: User): UserValidationErrors | undefined {
    const errors = validate(
      {
        email: user.email,
        profession: user.profession,
        ehr: user.ehr,
        workplace: user.workplace,
        phone: user.phone
      },
      {
        email: {
          presence: {
            allowEmpty: false,
            message: 'E-post er påkrevd'
          },
          email: {
            message: 'E-post er ikke gyldig'
          }
        },
        profession: {
          presence: {
            allowEmpty: false,
            message: 'Spesialitet er påkrevd'
          }
        },
        workplace: {
          presence: {
            allowEmpty: false,
            message: 'Legekontor er påkrevd'
          }
        },
        phone: {
          presence: {
            allowEmpty: false,
            message: 'Mobilnummer er påkrevd'
          },
          format: {
            pattern: "^[0-9]{8}$",
            message: "Mobilnummer må være et tall med 8 sifre"
          }
        },
        ehr: {
          presence: {
            allowEmpty: false,
            message: 'Journalsystem er påkrevd'
          }
        }
      },
      { fullMessages: false }
    );
    return errors;
  }
  
  /**
   * Checks if the given User object is valid.
   *
   * @param user The User object to check.
   * @returns True if valid; false if there are validation errors.
   */
  export function is_user_valid(user: User): boolean {
    return !validate_user(user);
  }


